import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { TableCellsService } from '../table-cells.service';

/**
 * Ячейка типа Галерея 'gallery'
 */
@Component({
    selector: 'app-gallery-cell',
    template: '<div class="flex flex-wrap gap-2" [innerHtml]="getHtml() | sanitizeHtml"></div>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryCellComponent extends BaseCellComponent {
    private readonly tableCellsService = inject(TableCellsService);
    getHtml() {
        const value = this.row[this.alias];
        if (!value) {
            return '';
        }
        return this.tableCellsService.getFileCreate(value, this.column.id as string);
    }
}
